
$(document).ready(function(){

$('.container li a.sub-menu').hover(function(){
    $('.blockNav').show();
  $('.blockNav').css('margin-top', '1px');
    
  }, function(){
    $('.blockNav').show();
  $('.blockNav').css('margin-top', '1px');
  
  } );
  
  
  $('.blockNav').hover(function(){
  	$(this).show();
    $(this).css('margin-top', '1px');

  }, function(){
    $(this).hide();
    $(this).css('margin-top', '0px');

  });
  $('.sale-link').hover(function(){
   $('.blockNav').hide();
  });
  $('[data-title]').hover(function(){
  	var showMenu = $(this).attr('data-title');
    $('.blockNav div[data-title]').each(function(){
      $(this).hide();
      $(this).css('margin-top', '0px');
    });
    $('.blockNav div[data-title="' + showMenu+ '"]').show();
    $('.blockNav div[data-title="' + showMenu+ '"]').css('margin-top', '1px');
  });
  

  
});

$(function () {

    $(window).load(function () {
        if ($('.flex-control-nav.flex-control-thumbs').children('li:visible').length <= 5
            && $('.flex-control-nav.flex-control-thumbs').children('li:visible').length > 0
            && $('.flex-control-nav.flex-control-thumbs').children('li:visible').length != 0) {
            showInTime();
        } else {
            showInTime();
            $('.image-controls').css('height', 'auto');
            $('.image-controls').show();
        }

        if ($('.text-collapse').length > 0) {
            $('.text-collapse').shorten();
        }

    });

    function showInTime() {
        $('.flex-control-nav.flex-control-thumbs').css('height', 'auto');
        $('.flex-control-nav.flex-control-thumbs').show();
    }

    function observerHelper(mutation) {
        if (mutation != undefined) {
            if ($(mutation.target).children('li:visible').length > 0 &&
                $(mutation.target).children('li:visible').length <= 5) {
                $('.image-controls').hide();
                showInTime();
            } else if ($(mutation.target).children('li:visible').length === 0) {
                $('.image-controls').hide();
            } else {
                showInTime();
                $('.image-controls').css('height', 'auto');
                $('.image-controls').show();
            }
        }
    }

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            observerHelper(mutation);
        });
    });

    function addMutationObserver($node) {
        console.log($node);
        observer.observe($node[0], {
            childList: true,
            attributes: true,
        });
    }

    if ($('.flex-control-nav').length > 0) {
        addMutationObserver($('.flex-control-nav'));
    }

    function CheckQuantity(action) {
        var variant_id = getQueryVariable('variant');
        if (typeof(boosterParams) !== 'undefined') {
            boosterParams.product.variants.forEach(function (el) {
                if (el.id == variant_id) {
                    var notice = $("#product_qty_notification");
                    if (el.inventory_management && (el.inventory_quantity < 10 && el.inventory_quantity > 0)) {
                        notice.text('Hurry! Only ' + el.inventory_quantity + ' left in stock.').show();
                    } else {
                        if ($(window).width() < 767 && action) {
                            window.scrollTo(0, 0);
                        }
                        notice.hide();
                    }
                }
            });
        }
    }

    CheckQuantity(false);

    //Product quantity notification
    $('body').on('click', '.swatchColor > div', function () {
        CheckQuantity(true);
    });

    $('body').on('click', '.swatch_options .swatch-element', function (e) {
        setTimeout(function () {
            CheckQuantity(true);
        }, 500);
    });

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (false);
    }

    $('.image-controls .btn-arrow-up').click(function () {
        var imageContainer = $(this).parents('.product_slider').children('.flex-control-nav');
        var scrollTop = imageContainer.scrollTop();
        imageContainer.animate({scrollTop: scrollTop - 150}, 130);

        if ($(this).closest('.product-v2').length) {
            var position = imageContainer.scrollLeft();
            imageContainer.animate({
                scrollLeft: position + 250
            }, 130);
        }
    });

    $('.image-controls .btn-arrow-down').click(function () {
        var imageContainer = $(this).parents('.product_slider').children('.flex-control-nav');
        var scrollTop = imageContainer.scrollTop();
        imageContainer.animate({scrollTop: scrollTop + 150}, 130);

        if ($(this).closest('.product-v2').length) {
            var position = imageContainer.scrollLeft();
            imageContainer.animate({
                scrollLeft: position - 250
            }, 130);
        }
    });


    $('.product_slider').on('start', function () {
        if ($('.flex-control-nav')[0].scrollHeight > $('.flex-control-nav').height()) {
            $('.product_slider .image-controls').show()
        }
        else {
            // $('.product_slider .image-controls').hide()
        }

        $('.product_slider .image-controls').detach().appendTo($('.product_slider'))
    });


    var postedContactInfo = false;

    //Contact form
    $('.contact-template-section #contact_form').submit(function (e) {
        if (!postedContactInfo) {
            var name = $('#contactFormName').val();
            var email = $('#contactFormEmail').val();
            var message = $('#contactFormMessage').val();

            var url = 'https://gaiamapi.azurewebsites.net/api/contactmessages';

            $.post(url, {
                name: name,
                email: email,
                message: message,
                message_datetime: (new Date()).toISOString()
            })
                .then(function () {
                    postedContactInfo = true;
                    $('.contact-template-section #contact_form').submit();
                });

            e.preventDefault();
        }

    });


    var postedEmail = false;

    //Contact form
    $('.newsletter #contact_form').submit(function (e) {
        if (!postedEmail) {
            var email = $('.newsletter .contact_email').val();

            var url = 'https://gaiamapi.azurewebsites.net/api/emailsubscribers';

            $.post(url, {
                email: email,
                website: "gaiam"
            })
                .then(function () {
                    postedEmail = true;
                    //$('.newsletter #contact_form').submit();
                    $('.newsletter #contact_form').hide();
                    $('.newsletter .message').html('Thanks for signing up!');
                });

            e.preventDefault();
        }
    });

    var API = $("#nav").data("mmenu");

    function realignFullWidthBox($parent) {
        var $container = $parent.parent();
        var offset = $container.offset();

        // The width of a document without a scrollbar
        var windowWidth = (document.documentElement.clientWidth || document.body.clientWidth);

        // Calc negative margins we need to achive full width effect
        var rightDiff = windowWidth - offset.left - $container.outerWidth();
        var leftDiff = offset.left;

        var styles = {
            marginRight: Math.min(-rightDiff, 0).toString() + "px",
            marginLeft: Math.min(-leftDiff, 0).toString() + "px"
        };

        // Override styles
        $parent.css(styles);
    }

    var $elems = $(".shg-fw");

    $(window).on("resize", function () {
        if (API.getInstance().vars.opened == true) {
            $elems.each(function (index, elem) {
                $(elem).removeAttr("style");
                $(elem).children(".shg-fw-inner").removeAttr("style");

                setTimeout(function () {
                    realignFullWidthBox($(elem));
                }, 500);
            });
            API.close();
        }
    });
    $(window).on("orientationchange", function () {
        if (API.getInstance().vars.opened == true) {
            $elems.each(function (index, elem) {
                $(elem).removeAttr("style");
                $(elem).children(".shg-fw-inner").removeAttr("style");

                setTimeout(function () {
                    realignFullWidthBox($(elem));
                }, 500);

            });
            API.close();
        }
    });
});

function checkHeaderTopIndent() {
    var winWidth = jQuery(window).width();
    var banner = jQuery('#shopify-section-header');
    var header = jQuery('#header');
    var mainPageWrapper = jQuery('body .global-wrapper');

    if (banner.length !== 0) {
        var bannerHeight = banner.outerHeight(true);
        var headerHeight = header.outerHeight(true);

        if (winWidth < 768) {
            banner.css({'top': headerHeight});
            mainPageWrapper.css({'padding-top': headerHeight + bannerHeight});
        } else {
            banner.css({'top': ''});
            mainPageWrapper.css({'padding-top': bannerHeight});
        }
    }
}

jQuery(window).on('load resize orientationchange', checkHeaderTopIndent);